import { DataService } from "@/services/data";
import { LMSDataService } from "@/services/lms_data";
import { Navigate, RouteObject, defer } from "react-router-dom";

const DPCRoute: RouteObject = {
    path: "dpc",
    children: [
        {
            index: true,
            async lazy() {
                let { DPCPage } = await import("@/pages/content/dpc/index");
                return { Component: DPCPage };
            },
            loader: async ({ request }) => {
                const url = new URL(request.url);
                if (!url.searchParams.has("page_size")) {
                    url.searchParams.set("page_size", "25");
                }
                const action_products = await LMSDataService.client
                    .url(`/andpc/products/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .get()
                    .json();
                const professions = DataService.client.url(`/content/professions/?sante=1`).get().json();
                return defer({ action_products, professions });
            }
        },
        {
            id: "content-dpc-detail",
            path: ":actionRef",
            async lazy() {
                let { DetailLayout } = await import("@/pages/content/dpc/detail-layout");
                return { Component: DetailLayout };
            },
            loader: async ({ params }) => {
                const actionRef = params.actionRef;
                const action_product = await LMSDataService.client.url(`/andpc/products/${actionRef}/`).get().json();
                return { action_product };
            },
            children: [
                {
                    index: true,
                    element: <Navigate to="formation" replace />
                },
                {
                    path: "formation",
                    async lazy() {
                        let { DetailProduct } = await import("@/pages/content/dpc/detail-product");
                        return { Component: DetailProduct };
                    }
                },
                {
                    path: "sessions",
                    async lazy() {
                        let { DetailSessions } = await import("@/pages/content/dpc/detail-sessions");
                        return { Component: DetailSessions };
                    },
                    loader: async ({ params }) => {
                        const actionRef = params.actionRef;
                        const action = await LMSDataService.client.url(`/andpc/actions/${actionRef}/`).get().json();
                        return { action };
                    }
                }
            ]
        }
    ]
};
export default DPCRoute;
